import { useState } from 'react'
import { NavMdiIcon } from '../NavTabIcons'
import type { TrainingDocumentDto } from './trainingDocument'
import {
  DEFAULT_TRAINING_ICON_BACKGROUND,
  DEFAULT_TRAINING_ICON_COLOR,
  DEFAULT_TRAINING_ICON_NAME,
  mdiPathFromIconName,
} from './mdiIconPath'

type TrainingDocumentIconProps = {
  document: TrainingDocumentDto
  size: 'list' | 'detail'
}

const SIZES = {
  list: { tile: 68, imageInset: 5, borderRadius: 10, vectorPx: 34 },
  detail: { tile: 80, imageInset: 6, borderRadius: 12, vectorPx: 40 },
} as const

export function TrainingDocumentIcon({ document: doc, size }: TrainingDocumentIconProps) {
  const s = SIZES[size]
  const remoteUrl = doc.iconUrl?.trim() || doc.categoryIconUrl?.trim() || ''
  const [remoteFailed, setRemoteFailed] = useState(false)
  const useRemote = !!remoteUrl && !remoteFailed

  const iconName = doc.iconName?.trim() || doc.categoryIconName?.trim() || DEFAULT_TRAINING_ICON_NAME
  const background =
    doc.iconBackgroundColor?.trim() ||
    doc.categoryIconBackgroundColor?.trim() ||
    DEFAULT_TRAINING_ICON_BACKGROUND
  const color = doc.iconColor?.trim() || doc.categoryIconColor?.trim() || DEFAULT_TRAINING_ICON_COLOR

  if (useRemote) {
    return (
      <div
        className={`training-doc-icon training-doc-icon--image training-doc-icon--${size}`}
        style={{
          width: s.tile,
          height: s.tile,
          borderRadius: s.borderRadius,
          padding: s.imageInset,
        }}
      >
        <img
          src={remoteUrl}
          alt=""
          onError={() => setRemoteFailed(true)}
        />
      </div>
    )
  }

  return (
    <div
      className={`training-doc-icon training-doc-icon--${size}`}
      style={{
        width: s.tile,
        height: s.tile,
        borderRadius: s.borderRadius,
        backgroundColor: background,
        color,
      }}
    >
      <NavMdiIcon
        path={mdiPathFromIconName(iconName)}
        sizePx={s.vectorPx}
        className="training-doc-icon-svg"
      />
    </div>
  )
}
